import { requests } from "./request" 
import { AffiliateType, ViewAffiliateType ,UpdateRefType } from '../models/affiliate.interface'

export  const affiliateApi = {
  getKey: (): Promise<any> => requests.post('affiliate/key', {}),
  getInfo: (): Promise<AffiliateType> => requests.get('affiliate/info'),
  getWalletAddress: (ref: string): Promise<any> =>
    requests.post('affiliate/referrer', {
      referralKey: ref,
    }),
  createView: (data: ViewAffiliateType): Promise<ViewAffiliateType> =>
    requests.post('stats/access-log', {
      referralKey: data.ref,
      walletAddress: data.buyerAddress,
    }),
  updateTx:(post: UpdateRefType ): Promise<any> => requests.patch('/affiliate/referrer', post)
}